import { render } from "./ChatGlobe.vue?vue&type=template&id=4ea4012a"
import script from "./ChatGlobe.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatGlobe.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/widgets/ChatGlobe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ea4012a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ea4012a', __exports__)) {
    api.reload('4ea4012a', __exports__)
  }
  
  module.hot.accept("./ChatGlobe.vue?vue&type=template&id=4ea4012a", () => {
    api.rerender('4ea4012a', render)
  })

}


export default __exports__